import axios from "@/utils/request.js";
import qs from "qs"
const currentUrl = window.location.href;
var pos = window.location.pathname
window.baseUrl = currentUrl.substring(0, currentUrl.indexOf(pos))
var baseUrl = process.env.NODE_ENV === 'production' ? window.baseUrl : process.env.VUE_APP_BASE_API
//  获取文件预览路径
const filePerviewPath = (data) => {
    let url = baseUrl + `/api/web-manager/file/manager/redirect/${data.fileObjId}/${data.downType}`
    return url
};
//获取内容评分设置
const getTenantList = (params) =>
    axios({
        url: '/api/web-conf/configuration/manager/tenant/list',
        method: 'get',
        params
    })
export {
    filePerviewPath,
    getTenantList
}